<div class="login-wrapper" *ngIf="!loginSuccess">
  <div class="login-card">

    <!-- Logo -->
    <div class="login-logo">
      <img src="assets/logo.svg" alt="NetClub Logo">
    </div>

    <h2 class="login-title">Log In</h2>

    <form #loginForm="ngForm" (ngSubmit)="loginForm.valid ? LogIn(loginUser, clubId) : null">

      <!-- Email -->
      <div class="field">
        <label>Email</label>
        <div class="password-input-wrapper">
          <input
            class="dk-input"
            type="email"
            placeholder="Enter your email"
            [(ngModel)]="loginUser.email"
            name="email"
            #email="ngModel"
            [readonly]="!emailmodel.canEditEmail"
            required
            email
          />
        </div>

        <mat-error *ngIf="email.invalid && (email.touched || loginForm.submitted)">
          {{ getEmailErrorMessage(email) }}
        </mat-error>
      </div>

      <!-- Password -->
      <div class="field">
        <label>Password</label>

        <div class="password-input-wrapper">
          <input
            class="dk-input"
            [type]="hidePassword ? 'password' : 'text'"
            placeholder="Enter your password"
            [(ngModel)]="loginUser.password"
            name="password"
            #password="ngModel"
            required
          />

          <mat-icon
            class="eye-icon"
            (click)="hidePassword = !hidePassword">
            {{ hidePassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </div>

        <mat-error *ngIf="password.invalid && (password.touched || loginForm.submitted)">
          Password is required
        </mat-error>

        <div class="forgot-wrapper">
          <span class="dk-link" (click)="forgotPassword()">
            Forgot password?
          </span>
        </div>
      </div>

      <!-- Login Button -->
      <button type="submit" class="dk-btn-primary">
        Log In
      </button>

      <!-- Footer -->
      <div class="login-footer">
        <span>New here?</span>
        <a routerLink="/register" class="dk-link">Register</a>
      </div>

    </form>
  </div>
</div>
